import { useEffect, useRef } from "react"
import io from "socket.io-client"
import { useStore } from "../store"

const MapBroadcaster = () => {
  const socket = useRef()
  const url = process.env.REACT_APP_MARKETING_SUITE
  const role = process.env.REACT_APP_ROLE

  const openSidebar = useStore(state => state.openSidebar)
  const setOpenSidebar = useStore(state => state.setOpenSidebar)

  const openMapVideo = useStore(state => state.openMapVideo)
  const setOpenMapVideo = useStore(state => state.setOpenMapVideo)

  const openClockSidebar = useStore(state => state.openClockSidebar)
  const setOpenClockSidebar = useStore(state => state.setOpenClockSidebar)

  const mapCategory = useStore(state => state.mapCategory)
  const setMapCategory = useStore(state => state.setMapCategory)

  const mapLocation = useStore(state => state.mapLocation)
  const setMapLocation = useStore(state => state.setMapLocation)

  const sidebarScrollPos = useStore(state => state.sidebarScrollPos)
  const setSidebarScrollPos = useStore(state => state.setSidebarScrollPos)

  const state = {
    mapCategory: mapCategory,
    mapLocation: mapLocation,
    openSidebar: openSidebar,
    openMapVideo: openMapVideo,
    openClockSidebar: openClockSidebar,
    sidebarScrollPos: sidebarScrollPos,
  }

  useEffect(() => {
    socket.current = io(url)
    socket.current.emit("subscribe-mapzustand", 1000)
    if (role === "recipient") {
      socket.current.on("mapzustand", actAptZustand => {
        setMapCategory(actAptZustand.mapCategory)
        setMapLocation(actAptZustand.mapLocation)
        setOpenSidebar(actAptZustand.openSidebar)
        setOpenMapVideo(actAptZustand.openMapVideo)
        setOpenClockSidebar(actAptZustand.openClockSidebar)
        setSidebarScrollPos(actAptZustand.sidebarScrollPos)
      })
    }
    return () => socket.current.close()
  }, [state, role, url])

  useEffect(() => {
    if (role === "sender") {
      socket.current.emit("mapzustand", state)
    }
  }, [state, role, url])

  return null
}

MapBroadcaster.propTypes = {}

export default MapBroadcaster
